var _path, _path2, _path3, _g, _path4, _g2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3151 10.1344C13.59 7.82146 8.50916 7.82094 4.77992 10.1349C4.35815 10.3971 4.09558 10.8767 4.09558 11.3867V11.6417C4.43103 11.5548 4.78302 11.508 5.14638 11.508C7.43613 11.508 9.29274 13.3547 9.29274 15.6321C9.29274 15.9581 9.25449 16.2753 9.18265 16.5796H17.5033C17.7777 16.5796 18 16.3585 18 16.0856V11.3867C18 10.8767 17.7374 10.3976 17.3151 10.1344Z",
    fill: "#7B83EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09555 16.0861V11.6422C2.31441 12.1049 1 13.7161 1 15.6326C1 17.9101 2.85661 19.7567 5.14636 19.7567C7.10841 19.7567 8.75206 18.401 9.18262 16.5801H4.59227C4.31781 16.5801 4.09555 16.359 4.09555 16.0861Z",
    fill: "#7B83EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14638 11.5085C4.78354 11.5085 4.43103 11.5553 4.09558 11.6422V16.0861C4.09558 16.359 4.31784 16.5801 4.5923 16.5801H9.18265C9.25449 16.2758 9.29274 15.9591 9.29274 15.6331C9.29274 13.3552 7.43613 11.5085 5.14638 11.5085Z",
    fill: "#235DC1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M17.2959 10.1303C15.2 8.82908 12.6751 8.25998 10.2029 8.42295C12.1241 8.54993 14.0127 9.11903 15.6419 10.1303C16.0642 10.393 16.3268 10.8726 16.3268 11.3831V16.0819C16.3268 16.3549 16.1045 16.576 15.8301 16.576H17.4841C17.7585 16.576 17.9808 16.3549 17.9808 16.0819V11.3831C17.9803 10.8726 17.7182 10.393 17.2959 10.1303Z",
    fill: "#235DC1"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.048 7.3269C13.0788 7.3269 14.7313 5.68333 14.7313 3.66345C14.7313 1.64356 13.0788 0 11.048 0C9.01725 0 7.36481 1.64356 7.36481 3.66345C7.36481 5.68333 9.01725 7.3269 11.048 7.3269Z",
    fill: "#7B83EB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M14.7359 3.66346C14.7359 1.85075 13.405 0.341368 11.6641 0.0509033C12.6395 0.952113 13.2509 2.23787 13.2509 3.66346C13.2509 5.08904 12.6395 6.3748 11.6641 7.27601C13.405 6.98554 14.7359 5.47616 14.7359 3.66346Z",
    fill: "#235DC1"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 15.064L5.8131 14.8764L5.26005 13.7048C5.2187 13.6174 5.07449 13.6174 5.03314 13.7048L4.48009 14.8764L3.24631 15.064C3.145 15.0795 3.10469 15.2023 3.1755 15.2743L4.07176 16.1884L3.85984 17.4803C3.84278 17.5831 3.95339 17.6597 4.04436 17.6093L5.14634 17.0037L6.24831 17.6098C6.33876 17.6597 6.44989 17.5841 6.43283 17.4808L6.22092 16.1889L7.11717 15.2748C7.1885 15.2023 7.14767 15.08 7.04688 15.064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.ae32a438e8bde1185e226d028124b0a1.svg";
export { ForwardRef as ReactComponent };